import { KnownOrderDtoStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { alpha, Avatar, Grid, Paper, Typography } from '@mui/material';
import { orderStatusBackgroundColors } from '../../../../orders/orders.constants';
import { orderStatusCountCardSubtitleMap } from '../../../dashboard.constants';
import { useStatusCountCardLargeStyles } from './status-count-card-large.styles';
import { StatusCountCardLargePlaceholder } from './status-count-card-large-placeholder.component';
import { Link } from 'react-router-dom';
import { SVGIconComponent } from '../../../../../ui/components/pure/icons/types';
import { useCurrentProject } from '../../../../../core/context/project.context';
import { getOrderStatusLabel } from '../../../../../core/util/status-label.util';

export function StatusCountCardLarge({
  count,
  status,
  link,
  Icon,
  isLoading,
  showSubtitle = true
}: {
  status?: string;
  count?: number;
  link?: string;
  Icon?: SVGIconComponent;
  isLoading: boolean;
  showSubtitle: boolean;
}) {
  const classes = useStatusCountCardLargeStyles();
  const { bookingFlowType } = useCurrentProject();

  if (isLoading || !status) {
    return <StatusCountCardLargePlaceholder />;
  }

  const iconColor = orderStatusBackgroundColors[status as KnownOrderDtoStatus];
  const title = getOrderStatusLabel(status as KnownOrderDtoStatus, bookingFlowType);
  const subtitle = orderStatusCountCardSubtitleMap[status as KnownOrderDtoStatus];

  return (
    <Link to={link || '#'} className={classes.link}>
      <Paper className={[classes.card, classes.clickable].join(' ')}>
        <Grid
          container
          style={{ height: '100%' }}
          wrap="nowrap"
          sx={{
            justifyContent: 'space-between',
            flexDirection: 'column'
          }}
        >
          <Grid>
            <Typography variant="h6" gutterBottom className={classes.title}>
              {title}
            </Typography>
          </Grid>
          <Grid>
            <div className={classes.iconWrapper}>
              <Avatar className={classes.avatar} style={{ backgroundColor: alpha(iconColor, 0.15) }}>
                {Icon ? <Icon className={classes.icon} color={iconColor} /> : <> </>}
              </Avatar>
            </div>
          </Grid>
          <Grid>
            {showSubtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
            <Typography className={classes.count}>{count ? count.toLocaleString() : 0}</Typography>
          </Grid>
        </Grid>
      </Paper>
    </Link>
  );
}
